var _g, _g2, _g3, _circle, _rect, _path, _rect2, _path2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceDailyJournaling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 136,
    viewBox: "0 0 286 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 96C65.6731 96 80 81.6731 80 64C80 46.3269 65.6731 32 48 32C30.3269 32 16 46.3269 16 64C16 81.6731 30.3269 96 48 96Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0286 76.6155L32.334 67.4775L42.7774 77.921L33.6394 79.2264L31.0286 76.6155Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.221 46.5974C55.1436 44.6748 58.2607 44.6748 60.1833 46.5974L63.6644 50.0785C65.587 52.0011 65.587 55.1182 63.6644 57.0408L61.9239 58.7813L51.4804 48.3379L53.221 46.5974Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.4795,
    y: 48.335,
    width: 14.7692,
    height: 27.0769,
    transform: "rotate(45 51.4795 48.335)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5932 79.6622L31.0283 76.6162L33.6392 79.2271L30.5932 79.6622Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5947,
    y: 74.4463,
    width: 7.38462,
    height: 1.23077,
    transform: "rotate(45 30.5947 74.4463)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.917,
    y: 47.8975,
    width: 14.7692,
    height: 1.23077,
    transform: "rotate(45 51.917 47.8975)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.2061,
    y: 66.6113,
    width: 14.7692,
    height: 1.23077,
    transform: "rotate(45 33.2061 66.6113)",
    fill: "#D89FEE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 96C161.673 96 176 81.6731 176 64C176 46.3269 161.673 32 144 32C126.327 32 112 46.3269 112 64C112 81.6731 126.327 96 144 96Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.029 76.6155L128.334 67.4775L138.777 77.921L129.639 79.2264L127.029 76.6155Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.221 46.5974C151.144 44.6748 154.261 44.6748 156.183 46.5974L159.664 50.0785C161.587 52.0011 161.587 55.1182 159.664 57.0408L157.924 58.7813L147.48 48.3379L149.221 46.5974Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.479,
    y: 48.335,
    width: 14.7692,
    height: 27.0769,
    transform: "rotate(45 147.479 48.335)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.593 79.6622L127.028 76.6162L129.639 79.2271L126.593 79.6622Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.595,
    y: 74.4463,
    width: 7.38462,
    height: 1.23077,
    transform: "rotate(45 126.595 74.4463)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.917,
    y: 47.8975,
    width: 14.7692,
    height: 1.23077,
    transform: "rotate(45 147.917 47.8975)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.206,
    y: 66.6113,
    width: 14.7692,
    height: 1.23077,
    transform: "rotate(45 129.206 66.6113)",
    fill: "#D89FEE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 104C262.091 104 280 86.0914 280 64C280 41.9086 262.091 24 240 24C217.909 24 200 41.9086 200 64C200 86.0914 217.909 104 240 104Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.786 79.7702L220.418 68.3477L233.472 81.4019L222.05 83.0337L218.786 79.7702Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.527 42.246C248.93 39.8427 252.826 39.8427 255.229 42.246L259.581 46.5974C261.984 49.0006 261.984 52.897 259.581 55.3002L257.405 57.476L244.351 44.4217L246.527 42.246Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.35,
    y: 44.418,
    width: 18.4615,
    height: 33.8461,
    transform: "rotate(45 244.35 44.418)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.241 83.577L218.785 79.7695L222.049 83.0331L218.241 83.577Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.243,
    y: 77.0586,
    width: 9.23077,
    height: 1.53846,
    transform: "rotate(45 218.243 77.0586)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.896,
    y: 43.8711,
    width: 18.4615,
    height: 1.53846,
    transform: "rotate(45 244.896 43.8711)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.508,
    y: 67.2637,
    width: 18.4615,
    height: 1.53846,
    transform: "rotate(45 221.508 67.2637)",
    fill: "#D89FEE"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 94L172.5 98L179.5 90",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 94L76.5 98L83.5 90",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 121,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 134.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 125.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 4L200 17",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 2L262.5 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218 119.5L212.5 131.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9731"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9731"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9731"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 24,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceDailyJournaling);
export default __webpack_public_path__ + "static/media/persistence-daily-journaling.7e2f46b278e4be2fdeeaeec613c397a8.svg";
export { ForwardRef as ReactComponent };